export const HTTP_STATUS_CODES = {
  BAD_REQUEST: 400,
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500,
  MISDIRECTED_REQUEST: 421,
  OK: 200,
  UNAUTHORIZED: 401
};
